export enum Extension {
  COMMERCETOOLS_PRODUCT_SELECTOR = 'product-selector',
  ALGOLIA_QUERY_SELECTOR = 'query-selector',
  ALGOLIA_CATEGORY_FACET = 'aloglia-category-facet',
  EXPERIMENT_SELECTOR = 'experiment-selector',
}
